import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CorrespondenceTeamDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-correspondenceteam',
  templateUrl: './correspondenceteam.component.html',
  styleUrls: ['./correspondenceteam.component.scss']
})
export class CorrespondenceteamComponent implements OnChanges {

  correspondenceTeamForm: FormGroup;
  correspondenceTeamFormArray: FormGroup;
  control = new FormControl();
  @Input() correspondenceTeams: CorrespondenceTeamDto[];
  @Input() routeAnimationsElements: any;
  @Output() correspondenceTeam = new EventEmitter<CorrespondenceTeamDto[]>()
  @Output() deleteCorrespondenceTeamEvent = new EventEmitter<any>()

    selectedCorrespondenceTeam: any;
    filteredDelete: Array<any> = [];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createCorrespondenceTeamForm();
    }

    createCorrespondenceTeamForm() {
      this.correspondenceTeamForm = this.fb.group({
        CorrespondenceTeamName: ['', Validators.required],
        Email: [''],
        id: null
        });
        this.correspondenceTeamFormArray = this.fb.group({ CorrespondenceTeams: this.fb.array([])
          });
        this.setCorrespondenceTeam();
    }

  // method to display correspondenceTeam
  setCorrespondenceTeam() {
    const control  = this.correspondenceTeamFormArray.controls.CorrespondenceTeams as FormArray;
    this.correspondenceTeams.forEach( e => {
      control.push(
        this.fb.group({
          CorrespondenceTeamName: e.CorrespondenceTeamName,
          Email: e.Email,
          id: e.id
        })
      );
    });
  }


  // method to add CorrespondenceTeam
  addCorrespondenceTeam(value: CorrespondenceTeamDto) {
    const control  = this.correspondenceTeamFormArray.controls.CorrespondenceTeams as FormArray;
    control.insert(0,
          this.fb.group({
            CorrespondenceTeamName: value.CorrespondenceTeamName,
            Email: value.Email,
            id: null
          })
       );
  }

  selectCorrespondenceTeam(value) {}

  // method to delete CorrespondenceTeam from arrary list
  deleteCorrespondenceTeam(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.correspondenceTeamFormArray.controls.CorrespondenceTeams as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.correspondenceTeams.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.correspondenceTeams[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: CorrespondenceTeamDto) {
    if(this.correspondenceTeamForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.correspondenceTeamFormArray.get('CorrespondenceTeams')['controls'][this.selectedIndex].patchValue({...formValue});
    } else {
      this.addCorrespondenceTeam(formValue);
    }
    this.selectedIndex = null;
    this.correspondenceTeamForm.reset()
  }

  onEdit(index, value: CorrespondenceTeamDto) {
    this.selectedIndex = index;
    this.correspondenceTeamForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.correspondenceTeamForm.reset();
  }

  onSubmit(formValue: CorrespondenceTeamDto[]) {
  this.correspondenceTeam.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteCorrespondenceTeamEvent.emit(this.filteredDelete);
  }
  }

}
